import { Dispatch } from 'redux';

import type { Device } from '@playq/octopus2-devices';

import { deviceToolkit } from './slice';

export const subscribeDevice = (dispatch: Dispatch) => {
  return (device: Device) => {
    dispatch(deviceToolkit.actions.setSubDevices(device.serialize()));
  };
};
export const unsubscribeDevice = (dispatch: Dispatch) => {
  return (id: string) => {
    dispatch(deviceToolkit.actions.unSubDevices(id));
  };
};

export const globalDispatch = (dispatch: Dispatch) => {
  return {
    subscribeDevice: subscribeDevice(dispatch),
    unsubscribeDevice: unsubscribeDevice(dispatch),
  };
};
